import { render } from "./fxxg.vue?vue&type=template&id=5a282664&scoped=true&ts=true"
import script from "./fxxg.vue?vue&type=script&lang=ts"
export * from "./fxxg.vue?vue&type=script&lang=ts"

import "./fxxg.vue?vue&type=style&index=0&id=5a282664&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a282664"]])

export default __exports__